/**
 * Multi-organisation warning
 *
 * Shown when a pool's campaigns belong to more than one organisation.
 */

import React from 'react';
import { Message } from 'semantic-ui-react';
import { Translate } from 'react-redux-i18n';
import { AlertTriangle } from 'lucide-react';
import { i18nKeys } from '../constants';
import Styles from '../GiftMatchingPools.module.css';

const MultiOrganisationWarning: React.FC = () => (
  <Message warning visible role="alert">
    <Message.Header className={Styles.warningHeader}>
      <AlertTriangle aria-hidden="true" size={18} />
      <Translate value={i18nKeys.WARNINGS.MULTI_ORGANISATION_TITLE} />
    </Message.Header>
    <p>
      <Translate value={i18nKeys.WARNINGS.MULTI_ORGANISATION} />
    </p>
  </Message>
);

export default MultiOrganisationWarning;
